import { Injectable } from '@angular/core';
declare let gtag: Function; // Declare ga as a function
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }
    // create our event emitter to send our data to Google Analytics
    public eventEmitter(eventCategory: string,
      eventAction: string,
      eventLabel: string = null,
      eventValue: string = null) {
        // gtag('event', eventAction , eventLabel, {'description': eventLabel, 'value' : eventValue, 'content_type': eventCategory});
        // gtag('event', eventAction ,  {'name': eventCategory, 'description': eventLabel, 'value' : eventValue, 'content_type': eventCategory});
        // gtag('event', eventAction, {
        //   'event_category': eventCategory + '-last',
        //   'event_label': eventLabel + '-last',
        //   'value': eventValue + '-last'
        // });
      }
}
